import React from 'react';
import { Controller } from 'react-hook-form';
import HookFormUtils from './HookFormUtils';
import MyTextField from '../MyTextField';
import { Tooltip, Box } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function HookFormTextField({
  control,
  schema,
  variant,
  type = 'text',
  loading,
  errors,
  label,
  helpText,
  prefix = null,
  ...others
}) {
  const error = HookFormUtils.getFieldError(errors, schema, prefix);
  const _schema = HookFormUtils.getSchemaName(schema, prefix);

  return (
    <Controller
      control={control}
      name={_schema}
      render={({ field: { onChange, value } }) => (
        <Box sx={{ position: 'relative', width: '100%' }}>
          <MyTextField
            onChange={onChange}
            name={_schema}
            value={value}
            type={type}
            variant={variant || 'outlined'}
            label={label}
            error={!!error}
            helperText={error && error.message}
            defaultValue={''}
            {...others}
          />
          {helpText && (
            <Tooltip title={helpText} arrow>
              <InfoOutlinedIcon
                sx={{
                  position: 'absolute',
                  right: 12,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  fontSize: 18,
                  color: 'text.secondary',
                  pointerEvents: 'auto',
                  cursor: 'pointer',
                }}
              />
            </Tooltip>
          )}
        </Box>
      )}
    />
  );
}
